export default __webpack_public_path__ + "9ca20259c2c3b7dc31fd072af16ab506.svg";